// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"21":"1d68c94f24ac06aa5d30","723":"1d68c94f24ac06aa5d30","887":"1d68c94f24ac06aa5d30","888":"8dbd6e417a6b32595713"}[chunkId] + ".css";
};